import { Link } from 'react-router-dom';
import './WhyChooseUs.css';
import workerImg from '../../assets/why_choose_team.png';
import iconTrust from '../../assets/figma_icon_trust.png';
import iconBadge from '../../assets/figma_icon_badge.png';
import iconChecklist from '../../assets/figma_icon_checklist.png';
import iconIteration from '../../assets/figma_icon_iteration.png';

const reasons = [
  {
    icon: iconTrust,
    title: 'Proven Systems You Can Rely On',
    desc: 'We only use trusted, proven brands that perform well in Australian conditions, built for long-term reliability and real savings.',
  },
  {
    icon: iconBadge,
    title: 'Carefully Selected, Qualified Installers',
    desc: 'We only work with carefully selected, fully qualified electricians, so you know your system is installed properly from day one.',
  },
  {
    icon: iconChecklist,
    title: 'Tailored to Your Home, Not a Sales Pitch',
    desc: 'Every system is designed around your actual energy usage and bills, with no upselling and no one-size-fits-all packages.',
  },
  {
    icon: iconIteration,
    title: 'We Handle Everything, Start to Finish',
    desc: "From consultation to installation and ongoing support, we take care of the entire process so you don't have to.",
  },
];

export default function WhyChooseUs() {
  return (
    <section className="why-section">
<div className="why-inner">
        <div className="why-card-wrap">
          <div className="why-left-card">
            <h2 className="why-title">
              Why homeowners choose{' '}
              <span className="why-title-yellow">Watt &amp; Wattle</span>
            </h2>
            <p className="why-desc">
              We make going solar simple, reliable, and built around your home, not a one-size-fits-all system.
            </p>
            <div className="why-reasons">
              {reasons.map((r, i) => (
                <div key={i} className="why-reason">
                  <div className="why-reason-icon-wrap">
                    <img src={r.icon} alt="" className="why-reason-icon" />
                  </div>
                  <div className="why-reason-text">
                    <h4 className="why-reason-title">{r.title}</h4>
                    <p className="why-reason-desc">{r.desc}</p>
                  </div>
                </div>
              ))}
            </div>
            <Link to="/contact" className="why-cta-btn">
              Speak to our team
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M5 12h14M12 5l7 7-7 7" stroke="#050b14" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Link>
          </div>
          <div className="why-right-img">
            <img src={workerImg} alt="Professional solar installer" />
          </div>
        </div>
      </div>
    </section>
  );
}
